import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../App";
import { Loader2, Scale } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuthUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from hash
      const hash = location.hash || window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const response = await axios.post(`${API}/auth/session`, 
          { session_id: sessionId },
          
        );

        setAuthUser(response.data.user);
        
        // Clear the hash and redirect to library
        window.history.replaceState(null, '', '/library');
        navigate('/library', { replace: true, state: { user: response.data.user } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center">
      <Scale className="h-12 w-12 text-gold mb-6" />
      <Loader2 className="h-8 w-8 text-gold animate-spin mb-4" />
      <p className="text-muted-foreground">Completing sign in...</p>
    </div>
  );
}
